import React, { useState, useEffect } from 'react';
import { Dropdown } from 'primereact/dropdown';
import { FloatLabel } from 'primereact/floatlabel';
import {config} from "../shared/config";
import * as util from '../shared/commons';
import axios from "axios";
import 'primeicons/primeicons.css';
import ShowError from "../shared/ShowError";
import { Col, Container, Row } from 'react-bootstrap';
import { propTypes } from 'react-bootstrap/esm/Image';


export default function ClientCombo(props) {
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(false);
    const [item, setItem] = useState(props.value);

    useEffect(() => {
        setLoading(true);
        var params = {
            login:util.getLoginDto(), 
            tafsilId:0, 
            searchText:"", 
            includeAdmins:props.includeAdmins, 
            includeAssistants:props.includeAssistants, 
            includeAgents:props.includeAgents, 
            includeClients:props.includeClients
        };
        var url = config.Server+`/user/list`;
        console.log("params is>", params);
        console.log("url is>", url);
        axios
        .post(url, params )
        .then(res => {
            var response = res.data;
            if(response.state === "ok"){
                response = response.data;
                for(var i=0;i<response.length;i++){
                    if(props.value)
                        if(props.value != null)
                            if(props.value.id == response[i].id) setItem(response[i]);

                    response[i]["title"] = response[i].tafsilId + " " + response[i].firstname + " " + response[i].lastname;
                }
                setItems(response);
                setLoading(false);
            }
            else{
                console.log("error is>", response.message)
            }
        })
        .catch(error => {
            console.log("error is>", error)
        });
    }, []);
    const getItem = function(items, id){
        if(items == null) return null;
        for(var i=0;i<items.length;i++){
            if(items[i].id == id) return items[i];
        }
        return null;
    }

    const onItemChanged = function (ii){
        if(!ii) ii = null;
        if(props.onChange){
            props.onChange(ii);
        }
    }


    return(
        <>
        {
            <>
            <Row style={{marginTop:"20px"}}>
                <Col>
                    <div className="card flex justify-content-center">
                        <FloatLabel className="w-full md:w-14rem">
                            <Dropdown inputId="cmb" value={item} onChange={(e) => {setItem(e.value); onItemChanged(e.value);}} options={items} optionLabel="title" className="w-full rtl-dropdown" 
                             checkmark={true} highlightOnSelect={true} filter showClear  style={{width:"100%"}} loading={loading} scrollHeight="350px"    
                            />
                            <label htmlFor="cmb">کاربر</label>
                        </FloatLabel>
                    </div>
                    
                </Col>
            </Row>
            </>
        }
        </>
    )
}